import { toPromise, execute } from 'apollo-link';
export var linkToExecutor = function (link) { return function (_a) {
    var document = _a.document, variables = _a.variables, context = _a.context, info = _a.info;
    return toPromise(execute(link, {
        query: document,
        variables: variables,
        context: {
            graphqlContext: context,
            graphqlResolveInfo: info,
            clientAwareness: {},
        },
    }));
}; };
//# sourceMappingURL=linkToExecutor.js.map